// extracted by mini-css-extract-plugin
module.exports = {"base":"EditorItem_base_39MvF"};